module.exports = __webpack_public_path__ + "static/img/icon-share.f7aedb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-share.png
// module id = T/sC
// module chunks = 1